import { Breadcrumbs as BreadcrumbsCrossComponent } from '@digital-retail/falabella-ui-cross-components';
import PropTypes from 'prop-types';

import { breadcrumbsStyles } from './style';

const Breadcrumbs = ({ items, appCtx, isPdpPage }) => {
  const { url, regionCode, host } = appCtx;

  return (
    <div className="breadcrumbs">
      <BreadcrumbsCrossComponent items={items} tenant={regionCode} host={host} path={url} isPdpPage={isPdpPage} />
      <style jsx>{breadcrumbsStyles}</style>
    </div>
  );
};

Breadcrumbs.propTypes = {
  items: PropTypes.array,
  appCtx: PropTypes.shape({
    host: PropTypes.string,
    url: PropTypes.string,
    tenant: PropTypes.string,
    store: PropTypes.string,
    environment: PropTypes.string,
    regionCode: PropTypes.string,
  }),
  isPdpPage: PropTypes.bool,
};

Breadcrumbs.defaultProps = {
  items: [],
  appCtx: {},
  isPdpPage: false,
};

export { Breadcrumbs };
export default Breadcrumbs;
